import { Base } from "ui/Scripts/source/framework/base";
import { IMessageListItem, MessageListItem } from "../message/messageListItem";

export interface IFrontPageMessage {
    messages: IMessageListItem[];
}

export class FrontPageMessage implements IFrontPageMessage {
    messages: MessageListItem[];

    constructor();
    constructor(obj: IFrontPageMessage);
    constructor(obj?: any) {
        this.messages = Base.getTypedArray(obj ? obj.messages : null, MessageListItem);
    }
}